api = require 'api'
{buildFetchPath} = require 'utils/service_helpers'


module.exports =

  create: (data) ->
    api.send
      method: 'POST'
      path: '/api/v2/classroomunits'
      payload: data


  delete: (id) ->
    api.send
      method: 'DELETE'
      path: "/api/v2/classroomunits/#{id}"


  fetch: (args) ->
    api.send
      method: 'GET'
      path: buildFetchPath args, '/api/v2/classroomunits'


  find: (id) ->
    api.send
      method: 'GET'
      path: "/api/v2/classroomunits/#{id}"


  update: (data) ->
    api.send
      method: 'PUT'
      path: "/api/v2/classroomunits/#{data._id}"
      payload: data
